/* JR 2 - caja de compra: selector 1/2 relojes, caja original opcional.
   Manda al carrito solo el reloj, con el regalo como propiedad de línea "Regalo"
   (caja de cuero + e-book). No se crean líneas de $0: 1 reloj = 1 AddToCart en píxel,
   WeTracked y Purchase. Si va con caja original (paga), esa sí es una línea aparte. */
(function () {
  'use strict';
  var PROP_GIFT = 'Regalo', PROP_BOX = 'Caja original', PROP_BOX_VID = '_caja_variant';
  function money(cents) {
    return '$' + new Intl.NumberFormat('es-AR', { maximumFractionDigits: 0, minimumFractionDigits: 0 }).format(Math.round(cents / 100));
  }
  function init(root) {
    if (root.dataset.jrReady) return;
    root.dataset.jrReady = '1';
    var variantId = Number(root.dataset.variantId);
    var price = Number(root.dataset.price) || 0;
    /* pack de 2: total y precios en transferencia calculados en Liquid (misma regla que el descuento automático) */
    var pack2Total = Number(root.dataset.pack2Total) || Math.round(price * 2);
    var transfer1 = Number(root.dataset.transfer1) || 0;
    var transfer2 = Number(root.dataset.transfer2) || 0;
    var boxVariant = Number(root.dataset.boxVariant) || 0;
    var boxPrice = Number(root.dataset.boxPrice) || 0;
    var boxTitle = root.dataset.boxTitle || '';
    var giftFull = root.dataset.giftFull || 'Caja de regalo de cuero + E-book El Manual del Reloj';
    var giftEbook = root.dataset.giftEbook || 'E-book El Manual del Reloj';
    var packs = root.querySelectorAll('.jr-pack');
    var boxLabel = root.querySelector('.jr-bb__box');
    var boxToggle = root.querySelector('[data-jr-box-toggle]');
    var boxEach = root.querySelector('[data-jr-box-each]');
    var btn = root.querySelector('[data-jr-buy]');
    var totalEl = root.querySelector('[data-jr-total]');
    var transferEl = root.querySelector('[data-jr-transfer]');
    var transferPct = Number(root.dataset.transferPct) || 0;
    var errEl = root.querySelector('[data-jr-error]');

    function qty() {
      var active = root.querySelector('.jr-pack.is-active');
      return active ? (parseInt(active.dataset.pack, 10) || 1) : 1;
    }
    function withBox() { return !!(boxToggle && boxToggle.checked && boxVariant); }
    function total() {
      var q = qty();
      var t = q === 2 ? pack2Total : price;
      if (withBox()) t += boxPrice * q;
      return t;
    }
    function transfer() {
      var q = qty();
      var t = q === 2 ? transfer2 : transfer1;
      if (!t) t = Math.round(total() * (100 - transferPct) / 100);
      if (withBox()) t += Math.round(boxPrice * q * (100 - transferPct) / 100);
      return t;
    }
    function refresh() {
      if (totalEl) totalEl.textContent = money(total());
      /* precio en transferencia/efectivo del pack elegido */
      if (transferEl) transferEl.textContent = money(transfer());
      if (boxEach) boxEach.hidden = qty() < 2;
      if (boxLabel) boxLabel.classList.toggle('is-on', withBox());
    }
    Array.prototype.forEach.call(packs, function (p) {
      var input = p.querySelector('input[type="radio"]');
      function select() {
        Array.prototype.forEach.call(packs, function (o) { o.classList.remove('is-active'); });
        p.classList.add('is-active');
        if (input) input.checked = true;
        refresh();
      }
      p.addEventListener('click', function (ev) { if (ev.target.tagName !== 'INPUT') { ev.preventDefault(); } select(); });
      if (input) input.addEventListener('change', function () { if (input.checked) select(); });
    });
    if (boxToggle) boxToggle.addEventListener('change', refresh);

    if (btn) btn.addEventListener('click', function () {
      if (!variantId || !window.JRCart) return;
      var q = qty(), wb = withBox();
      var props = {};
      if (wb) {
        props[PROP_GIFT] = giftEbook;
        props[PROP_BOX] = boxTitle;
        props[PROP_BOX_VID] = String(boxVariant);
      } else {
        props[PROP_GIFT] = giftFull;
      }
      var items = [{ id: variantId, quantity: q, properties: props }];
      if (wb) items.push({ id: boxVariant, quantity: q });
      btn.classList.add('loading');
      if (errEl) errEl.hidden = true;
      window.JRCart.addItems(items).then(function () {
        btn.classList.remove('loading');
      }).catch(function (e) {
        btn.classList.remove('loading');
        if (errEl) { errEl.textContent = 'No pudimos agregar el producto. Probá de nuevo.'; errEl.hidden = false; }
        console.error('[jr-buy-box]', e);
      });
    });
    refresh();
  }
  function scan() { Array.prototype.forEach.call(document.querySelectorAll('[data-jr-buy-box]'), init); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', scan); } else { scan(); }
  document.addEventListener('shopify:section:load', scan);
})();
